import { DrawParams } from "./types";
import getBandwidth from "util/eqMathHelpers/getBandwidth";
import getQFromBandwidthOctaves from "util/eqMathHelpers/getQFromBandwidthOctaves";

export default function drawSafeArea({
  svg,
  xScale,
  freq,
  safeAreaInOctaves,
  contentHeight,
}: DrawParams) {
  const selector = "safeArea";

  svg
    .selectAll(`rect.${selector}`)
    .data([1])
    .join("rect")
    .attr("class", `${selector} fill-purple-100 opacity-20`)
    .attr(
      "x",
      noNegative(
        xScale(
          getBandwidth(freq, getQFromBandwidthOctaves(safeAreaInOctaves))
            .lowerFreq
        )
      )
    )
    .attr(
      "width",
      noNegative(
        xScale(
          getBandwidth(freq, getQFromBandwidthOctaves(safeAreaInOctaves))
            .upperFreq
        ) -
          xScale(
            getBandwidth(freq, getQFromBandwidthOctaves(safeAreaInOctaves))
              .lowerFreq
          )
      )
    )
    .attr("y", 0)
    .attr("height", contentHeight);
}

function noNegative(num: number) {
  if (num < 0) {
    return 0;
  }

  return num;
}
